// Shared form/server validation. A stated birthday is not identity verification.
export function validateProfile(value, now = Date.now()) {
  const birthdate = value?.birthdate;
  if (typeof birthdate !== 'string' || !/^\d{4}-\d{2}-\d{2}$/.test(birthdate)) return { error: 'invalid_birthdate' };
  const date = new Date(birthdate + 'T00:00:00Z'), today = new Date(now);
  if (!Number.isFinite(date.getTime()) || date.toISOString().slice(0, 10) !== birthdate || date.getUTCFullYear() < 1900 || date > today) return { error: 'invalid_birthdate' };
  const birthdayAhead = today.getUTCMonth() < date.getUTCMonth() ||
    (today.getUTCMonth() === date.getUTCMonth() && today.getUTCDate() < date.getUTCDate());
  if (today.getUTCFullYear() - date.getUTCFullYear() - Number(birthdayAhead) < 18) return { error: 'adult_required' };
  return { profile: { birthdate } };
}
